import React from 'react'
import {PAYPAL_FORM_ID, HiddenPaypalForm} from './PaypalButton'
import { Button, Typography, useTheme } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import NewsTicker from './NewsTicker'

function SanPedroFacebook({ vh = 0.6, isMobile }) {
  const aspectRatio = 720 / 1280; // YouTube video aspect ratio

  return (
    <div
      style={{
        width: "100%",
        height: isMobile ? "40vh" : `${vh * 100}vh`,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <iframe
        src="https://www.youtube.com/embed/WnHTx6dfCIw?&autoplay=1&loop=1&mute=1&playsinline=1&controls=0&showinfo=0&playlist=WnHTx6dfCIw"
        frameBorder="0"
        allowFullScreen
        title="San Pedro Video"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "177.78%",  // 100 / (9/16) to cover width for 16:9 ratio
          height: "177.78%", // ensures height fills container and crops top/bottom
          transform: "translate(-50%, -50%)",
        }}
      />
    </div>
  );
}

function SanPedroWelcomeMessage({ isMobile }) {
  const handleClick = () => {
    document.getElementById(PAYPAL_FORM_ID).submit()
  } 

  return (
    <div
      style={{
        paddingLeft: isMobile ? "16px" : "15%",
        paddingRight: isMobile ? "16px" : "15%",
        paddingTop: "1%",
        paddingBottom: isMobile ? "12px" : 0,
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        gap: isMobile ? 16 : 50,
        alignItems: isMobile ? "stretch" : "center",
        boxSizing: "border-box",
        width: "100%"
      }}
    >
      <Typography variant="h6">
        <span style={{ fontFamily: "'Cinzel', serif", fontWeight: 700 }}>Bom dia, bom povo!</span> The San Pedro Association is a Madeiran Portuguese Heritage Association focused
        on maintaining its historical presence in the West Sacramento community and
        preservation of its historical San Pedro Park. <span style={{ fontFamily: "'Cinzel', serif", fontWeight: 700 }}>Obrigado!</span>
      </Typography>
      <Button
        variant="contained"
        style={{
          width: isMobile ? "100%" : 250,
          height: isMobile ? 52 : 76,
          flexShrink: 0,
          fontFamily: "'Cinzel', serif",
          fontWeight: 700,
          fontSize: isMobile ? "1rem" : "1.35rem",
          letterSpacing: isMobile ? "0.02em" : "0.05em",
          lineHeight: 1
        }}
        onClick={handleClick}
      >
        DONATE NOW
        <HiddenPaypalForm />
      </Button>
    </div>
  )
}

function NonprofitMessage() {
  return (
    <div
      style={{
        paddingLeft: "20%",
        paddingRight: "20%"
      }}
    >
      <Typography variant="body2">
        A California Exempt Nonprofit Mutual Benefit Corp.(rtc23701f), (C 0272992)
        <br />
        An IRS 501c (7) Exempt Corp., FTxID/EIN: 02-0760640, (eff: 12/6/2005)
      </Typography>

    </div>
  )
}


export default function HomePage() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    }}
    >
      <SanPedroWelcomeMessage isMobile={isMobile} />
      <NewsTicker />
      <SanPedroFacebook isMobile={isMobile} />
      {/* <PaypalButton /> */}
      {/* <NonprofitMessage /> */}
    </div>
  )
}